export const customizationPageTestIds = {
  customizationFlagName: (name) => `customization-flag-name-${name}`,
  customizationFlagStatus: (status: string) =>
    `customization-flag-status-${status.toLowerCase()}`,
  customizationFlagStatusProhibitedFlagWarningDot: 'prohibited-flag-warning-dot',
  customizationFlagSoftwareOnlyOption: 'software-only-option',
};
